import { Fragment } from 'react';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var LINE_BREAKS = /\r\n|\r|\n/;
var ZERO_WIDTH_WHITE_SPACE = '\u200B';
export function Text(_ref) {
  var {
    node
  } = _ref;
  var {
    bold,
    italic,
    subscript,
    superscript,
    text,
    underlined,
    highlighted
  } = node;
  var children = Text.preserveSoftBreaks(text);
  if (bold) {
    children = /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  if (italic) {
    children = /*#__PURE__*/_jsx("em", {
      children: children
    });
  }
  if (subscript) {
    children = /*#__PURE__*/_jsx("sub", {
      children: children
    });
  }
  if (superscript) {
    children = /*#__PURE__*/_jsx("sup", {
      children: children
    });
  }
  if (underlined) {
    children = /*#__PURE__*/_jsx("u", {
      children: children
    });
  }
  if (highlighted) {
    children = /*#__PURE__*/_jsx("mark", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}
Text.preserveSoftBreaks = text => {
  var nodes = text.split(LINE_BREAKS).reduce((result, part, index) => result.length === 0 ? [part] : [...result, /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), ZERO_WIDTH_WHITE_SPACE]
  }, index), part], []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: nodes
  });
};